module.exports = __webpack_public_path__ + "static/media/usdt.f1807872.svg";